/*
 =========================================================
 * Vue Black Dashboard - v1.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/black-dashboard
 * Copyright 2018 Creative Tim (http://www.creative-tim.com)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import { createApp } from "vue";
import App from "./App";
// TIP: change to import router from "./router/starterRouter"; to start with a clean layout
import router from "./router/index";

import BlackDashboard from "./plugins/blackDashboard";
import i18n from "./i18n"
//import './registerServiceWorker'

// vue-clipboard3 doesn't need to be imported globally

// CodeMirror imports available for individual components that need them
// import { basicSetup } from 'codemirror'
// import { html } from '@codemirror/lang-html'
// import { oneDark } from '@codemirror/theme-one-dark'

import Vue3Toastify from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import VueHighlightJS from 'vue-highlightjs';
import 'highlight.js/styles/default.css';

const app = createApp(App);

// Register plugins
app.use(router);
app.use(i18n);
app.use(BlackDashboard);
app.use(VueHighlightJS);
// Day.js configuration with plugins
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'   // for fromNow()
import advancedFormat from 'dayjs/plugin/advancedFormat' // for Do (1st, 2nd…)
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone' // for time zones
import 'dayjs/locale/en' // English locale

dayjs.extend(relativeTime)
dayjs.extend(advancedFormat)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('en')

// Make dayjs available globally in templates
app.config.globalProperties.$dayjs = dayjs;
// vue-clipboard3 is used via composables, no global registration needed

// CodeMirror configuration moved to individual components that need it

app.use(Vue3Toastify, {
  autoClose: 3000,
  position: 'bottom-right'
});

app.mount("#app");
